import $ from 'jquery';
import EventEmitter from 'eventemitter3';

import checkIfVisible from './checkIfVisible';

const MIN_GUTTER_SIZE = 85;

/**
 * Carousel for the Recommendations List
 */
class Carousel extends EventEmitter {
  static updateState() {
    const $container = $('#ev-recommendations');
    const $list = $('.ev-recommendation-list');
    const totalRecos = $list.find('.ev-recommendation').length;
    const currentStep = +$list.attr('data-step');
    const steps = +$list.attr('data-steps');
    const stepMargin = +$list.attr('data-step-margin');
    const minVisible = +$list.attr('data-steps-min-visible');
    const maxVisible = +$list.attr('data-steps-max-visible');

    // If no container can be found skip the rest
    if (!$container.length) {
      return;
    }

    // Calculate the target left offset to align with the desired state
    let targetLeft;
    let stepsVisible = minVisible;
    if (currentStep === 0) {
      targetLeft = 0;
      stepsVisible = maxVisible;
    } else {
      const $targetReco = $(`.ev-recommendation:eq(${currentStep})`);
      const itemWidth = $targetReco.outerWidth();
      const containerWidth = $container.width();

      if (currentStep === steps) {
        // The last step should be right-aligned with the edge
        const lastPosition = $('.ev-recommendation:last').position();
        targetLeft = lastPosition.left + itemWidth - containerWidth + stepMargin;
        stepsVisible = maxVisible;
      } else {
        const itemPosition = $targetReco.position();

        const visibleContentWidth = (itemWidth * minVisible) + (stepMargin * (minVisible - 1));
        const actualGutter = (containerWidth - visibleContentWidth) / 2;

        targetLeft = itemPosition.left + stepMargin - actualGutter + 1; // off by 1 for why?!?
      }
    }

    // Slide the carousel so that it is in the correct position for the current step
    $list.css('transform', `translateX(-${targetLeft}px)`)
      .attr('data-steps-visible', stepsVisible);

    // Update the data-visible attribute on each of the recommendations
    $list.find('.ev-recommendation').each((i, el) => {
      const visible = Math.min(currentStep, totalRecos - stepsVisible) <= i && i < currentStep + stepsVisible;
      $(el).attr('data-visible', visible);
    });

    // Update the actions to have the appropriate target index and disabled state
    const previousStep = currentStep - 1;
    const nextStep = currentStep + 1;

    $('.ev-recommendation-carousel-action.ev-carousel-previous')
      .attr('data-target-step', previousStep)
      .attr('disabled', previousStep < 0 ? 'disabled' : false);

    $('.ev-recommendation-carousel-action.ev-carousel-next')
      .attr('data-target-step', nextStep)
      .attr('disabled', nextStep > steps || stepsVisible >= totalRecos ? 'disabled' : false);
  }

  init() {
    // Add the ev-recommendation-carousel class to the container to init the carousel elements
    $('#ev-recommendations').addClass('ev-recommendation-carousel');

    // Baseline the visibility of the component
    this.updateVisibility(true);

    // Emit the init event
    this.emit('init');
  }

  shift(forward = true) {
    // Calculate the target step based on an increment or decrement of the current step
    const $list = $('.ev-recommendation-list');
    const currentStep = +$list.attr('data-step');
    const targetStep = currentStep + (forward ? 1 : -1);

    return this.shiftToStep(targetStep);
  }

  shiftToIndex(index) {
    // Calculate the target step based on the specified recommendation index
    const $list = $('.ev-recommendation-list');
    const currentStep = +$list.attr('data-step');
    const steps = +$list.attr('data-steps');
    const stepsVisible = (currentStep === 0 || currentStep === steps)
      ? +$list.attr('data-steps-min-visible') : +$list.attr('data-steps-visible');

    const targetStep = index - (currentStep < index ? (stepsVisible - 1) : 0);
    return this.shiftToStep(targetStep);
  }

  shiftToRecommendation(recommendationId) {
    const $recommendation = $(`.ev-recommendation[data-recommendation-id="${recommendationId}"]`);
    if (!$recommendation.length || $recommendation.is('[data-visible="true"]')) {
      // The recommendation could not be found or it is already visible
      return false;
    }

    const index = +$recommendation.data('index');
    return this.shiftToIndex(index);
  }

  shiftToStep(targetStep) {
    const $list = $('.ev-recommendation-list');
    const currentStep = +$list.attr('data-step');
    const steps = +$list.attr('data-steps');
    const stepsVisible = +$list.attr('data-steps-visible');

    // Don't shift if the index is out of bounds or it's already the current step
    if (targetStep < 0 || targetStep > steps || currentStep === targetStep) {
      return false;
    }

    // Update the current step indicator to show where it's currently at
    $list.attr('data-step', targetStep);

    // Update the carousel state
    Carousel.updateState();

    // Publish an event indicating that the carousel was shifted
    this.emit('shift', {
      activeStep: targetStep,
      previousStep: currentStep,
      numVisible: stepsVisible,
      totalSteps: steps,
    });

    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  updateVisibility(isInit) {
    const $container = $('#ev-recommendations');
    const $list = $('.ev-recommendation-list');
    const $recommendations = $list.find('.ev-recommendation');
    const totalRecos = $recommendations.length;

    const storedMinStepSize = +$list.attr('data-step-min-size') || 0;
    const storedMaxStepSize = +$list.attr('data-step-max-size') || 0;

    // Use the container's bounding rect since the carousel is adjusting the rest of the size
    const parentBoundingRect = $container.length ? $container[0].getBoundingClientRect() : null;

    let minStepSize = 0;
    let maxStepSize = 0;

    // Update each recommendation's data-visible attribute
    $recommendations.each((i, el) => {
      const visible = checkIfVisible(el, parentBoundingRect, 0.98);

      const $el = $(el);
      $(el).attr('data-visible', visible);

      maxStepSize = Math.max(maxStepSize, $el.outerWidth(true));
      minStepSize = Math.min(maxStepSize, $el.outerWidth());
    });

    // Determine the right step size to use
    minStepSize = storedMinStepSize || minStepSize;
    maxStepSize = storedMaxStepSize || maxStepSize;

    // Update the list's data attributes so we can easily shift step through it
    setTimeout(() => {
      const containerWidth = $container.width();

      const minVisible = Math.max(Math.floor((containerWidth - (MIN_GUTTER_SIZE * 2)) / minStepSize), 1);
      const maxVisible = Math.max(Math.floor((containerWidth - MIN_GUTTER_SIZE) / minStepSize), 1);

      if (!isInit) {
        // Add CSS class for responsive width styling
        $list.toggleClass('dynamic-width', totalRecos <= 2 && maxVisible >= totalRecos);

        // Store the first non-zero set of step sizes, these values will
        // be used in subsequent calls in case dynamic width is enabled
        if (minStepSize > 0 && minStepSize !== storedMinStepSize) {
          $list.attr('data-step-min-size', minStepSize);
        }
        if (maxStepSize > 0 && maxStepSize !== storedMaxStepSize) {
          $list.attr('data-step-max-size', maxStepSize);
        }
      }

      const steps = totalRecos - minVisible;
      const margin = maxStepSize - minStepSize;
      const stepsVisible = totalRecos - steps;

      $list
        .attr('data-step-margin', margin)
        .attr('data-steps', steps)
        .attr('data-steps-min-visible', minVisible)
        .attr('data-steps-max-visible', maxVisible)
        .attr('data-steps-visible', stepsVisible);

      // Update the state of the carousel
      Carousel.updateState();
    }, 0);
  }
}

export default Carousel;
